import React from "react";
import ComingSoon from "components/coming-soon";
import { GetServerSideProps } from "next";
import { wrapper } from "store";
import { updateDefault } from "features/seo/seoSlice";

/* eslint-disable @typescript-eslint/no-empty-interface */
interface Props {}

export const getServerSideProps: GetServerSideProps = wrapper.getServerSideProps(
  (store) => async () => {
    store.dispatch(updateDefault({}));
    return {
      props: {},
    };
  }
);

const Page: React.FC<Props> = () => {
  return (
    <div className="w-full mt-8">
      <ComingSoon />
    </div>
  );
};

export default Page;
